import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { studioInfo, socialLinks } from '../data/mock';
import { Instagram, Facebook, MessageCircle } from 'lucide-react';

const Footer = () => {
    const { t, language, isRTL } = useLanguage();
    const currentYear = new Date().getFullYear();

    return (
        <footer className='bg-[#0a0a0a] py-12 border-white/10 border-t'>
            <div className='mx-auto px-4 lg:px-8 max-w-6xl'>
                <div className='items-center gap-12 grid md:grid-cols-3'>
                    {/* Logo & Info */}
                    <div className='text-center md:text-start'>
                        <div className='flex justify-center md:justify-start items-center gap-3 mb-4'>
                            <img
                                src={studioInfo.logo}
                                alt={studioInfo.name}
                                className='rounded-full w-10 h-10 object-contain'
                            />
                            <span className='font-display text-white text-lg'>
                                Raz Tattoo
                            </span>
                        </div>
                        <p className='text-mid-grey text-sm'>
                            {language === 'he'
                                ? 'סטודיו לקעקועים ופירסינג'
                                : 'Tattoo & Piercing Studio'}
                        </p>
                    </div>

                    {/* Social Links */}
                    <div className='text-center'>
                        <p className='mb-4 text-mid-grey text-sm'>
                            {t.footer.followUs}
                        </p>
                        <div className='flex justify-center items-center gap-4'>
                            <a
                                href={socialLinks.instagram}
                                target='_blank'
                                rel='noopener noreferrer'
                                className='bg-white/5 hover:bg-mid-purple/20 p-3 rounded-full text-white hover:text-mid-purple transition-all duration-300'
                                aria-label='Instagram'
                            >
                                <Instagram className='w-5 h-5' />
                            </a>
                            <a
                                href={socialLinks.facebook}
                                target='_blank'
                                rel='noopener noreferrer'
                                className='bg-white/5 hover:bg-mid-blue/20 p-3 rounded-full text-white hover:text-mid-blue transition-all duration-300'
                                aria-label='Facebook'
                            >
                                <Facebook className='w-5 h-5' />
                            </a>
                            <a
                                href={socialLinks.whatsapp}
                                target='_blank'
                                rel='noopener noreferrer'
                                className='bg-white/5 hover:bg-mid-green/20 p-3 rounded-full text-white hover:text-mid-green transition-all duration-300'
                                aria-label='WhatsApp'
                            >
                                <MessageCircle className='w-5 h-5' />
                            </a>
                        </div>
                    </div>

                    {/* Copyright */}
                    <div className='text-center md:text-end'>
                        <p className='text-mid-grey text-sm'>
                            © {currentYear} {studioInfo.name}
                        </p>
                        <p className='mt-1 text-dark-grey text-xs'>
                            {t.footer.rights}
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
